import styled from 'styled-components';
import { ReactComponent as RawDesktopSVG } from '../../../../assets/icons/icon_desktop.svg';

export const IconDesktop = styled(RawDesktopSVG)``;